module.exports = __webpack_public_path__ + "static/user2-96a15c5cc5d1b68cfd561097cc556351.png";